<div class="bg-dark min-h-screen">
  <div class="container mx-auto px-4 py-16 text-light">
    <div class="max-w-4xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-6 text-primary text-center">Verantwoord Gokken</h1>
      <p class="text-lg mb-12 text-center text-gray-300">
        Uw veiligheid en welzijn staan bij ons voorop
      </p>

      <!-- 18+ Warning -->
      <div class="bg-primary/20 border border-primary p-8 rounded-lg mb-8 text-center">
        <div class="text-6xl font-bold text-primary mb-4">18+</div>
        <p class="text-xl font-semibold text-light mb-2">Alleen</p>
        <p class="text-gray-300">
          Deze website is alleen bedoeld voor personen van 18 jaar en ouder. Gokken kan verslavend zijn.
        </p>
      </div>

      <div class="grid md:grid-cols-2 gap-8 mb-12">
        <!-- Help Section -->
        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"></path>
              </svg>
            </div>
            <h2 class="text-2xl font-semibold text-light">Hulp en Ondersteuning</h2>
          </div>
          <p class="text-gray-300 mb-6">
            Als u denkt dat u een gokprobleem heeft, zijn er verschillende organisaties die u kunnen helpen:
          </p>
          <div class="space-y-4">
            <a href="https://www.gamstop.co.uk" target="_blank" rel="noopener" class="block p-4 bg-dark rounded-lg border border-light/10 hover:border-primary/50 transition-all">
              <div class="font-semibold text-primary mb-1">GamStop</div>
              <div class="text-sm text-gray-400">Zelfuitsluiting voor UK spelers</div>
            </a>
            <a href="https://www.gambleaware.org" target="_blank" rel="noopener" class="block p-4 bg-dark rounded-lg border border-light/10 hover:border-primary/50 transition-all">
              <div class="font-semibold text-primary mb-1">GambleAware</div>
              <div class="text-sm text-gray-400">Onafhankelijke informatie en advies</div>
            </a>
            <a href="https://www.gokkeninfo.nl" target="_blank" rel="noopener" class="block p-4 bg-dark rounded-lg border border-light/10 hover:border-primary/50 transition-all">
              <div class="font-semibold text-primary mb-1">Gokken Info</div>
              <div class="text-sm text-gray-400">Nederlandse hulplijn</div>
            </a>
          </div>
        </section>

        <!-- Tips Section -->
        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h2 class="text-2xl font-semibold text-light">Tips voor Verantwoord Gokken</h2>
          </div>
          <ul class="space-y-4">
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Stel een budget vast en houd u eraan</span>
            </li>
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Gok nooit met geld dat u niet kunt missen</span>
            </li>
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Neem regelmatig pauzes</span>
            </li>
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Gok niet wanneer u onder invloed bent</span>
            </li>
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Gebruik zelfuitsluitingstools als u denkt dat u hulp nodig heeft</span>
            </li>
          </ul>
        </section>
      </div>

      <!-- Regulatory Signs -->
      <div class="mt-8">
        <app-regulatory-signs></app-regulatory-signs>
      </div>
    </div>
  </div>
</div>

